export const LIANDER_REGIONS = [
  'Flevoland',
  'Friesland',
  'Gelderland',
  'Noord-Holland',
  'Zuid-Holland',
];
export const LIANDER_CONGESTION_TYPES = ['Verbruik', 'Teruglevering'];
export const LIANDER_CONGESTION_STATUS = ['Lopend', 'Afgerond'];

